// Purge silencieuse des paniers zombies laissés par la V1 « cadeaux de palier »
// (JS supprimé lors de la bascule Dr Free Gift, 2026-07-19 nuit).
//
// Contexte : la V1 auto-ajoutait un cadeau au franchissement du seuil 49 € en
// marquant la ligne avec la propriété `_palier`. Après la suppression de V1,
// ces lignes fantômes persistent dans le cart cookie Shopify (glissant 14j),
// visibles au checkout comme un cadeau facturé — que Dr Free Gift ne peut pas
// nettoyer puisqu'il ne les a pas créées.
//
// Ce fichier détecte ces lignes au chargement et les retire via /cart/change.js.
// Silencieux pour les clientes non concernées. Recharge la page une seule fois
// si au moins un zombie a été purgé (garantit la synchro tiroir/barre DFG).
//
// Suppression future : quand aucun panier n'active plus ce cleanup depuis
// plusieurs semaines consécutives. Aucune date d'expiration codée en dur —
// le cookie Shopify étant glissant, une échéance calendaire ne prouverait rien.
(async () => {
  try {
    const cart = await fetch('/cart.js').then((r) => r.json());
    const zombies = cart.items.filter((i) => i.properties && i.properties._palier);
    if (!zombies.length) return;
    for (const line of zombies) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: line.key, quantity: 0 }),
      });
    }
    window.location.reload();
  } catch (_) {
    // Silencieux : un échec de purge ne doit jamais bloquer la cliente.
  }
})();
